module.exports = __webpack_public_path__ + "static/media/bgClear.8efbab7d.jpg";